import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  CONFIGURATION_DIALOG_ACTIONS,
  SubmissionDialogData,
  SubmissionsDialogComponent,
} from '@data-access/configurations';
import { ComponentType } from '@angular/cdk/overlay';

@Injectable()
export class SubmissionDialogService {
  private readonly _store = inject(Store);

  open(data: SubmissionDialogData) {
    this._store.dispatch(
      CONFIGURATION_DIALOG_ACTIONS.openConfigurationDialog({
        component: () =>
          SubmissionsDialogComponent as ComponentType<SubmissionsDialogComponent>,
        data: data,
      }),
    );
  }
}
